import { clsx } from 'clsx'
import { type FC } from 'react'

import { Spinner, Text, VStack, type VStackProps } from '@/components'
import { COLOR_WHITE } from '@/lib'

export interface LoadingViewProps extends Omit<VStackProps, 'children'> {
  message?: string
  size?: 'sm' | 'lg'
}

export const LoadingView: FC<LoadingViewProps> = ({ className, message = 'Loading...', size = 'lg' }) => (
  <VStack
    accessible
    accessibilityLabel={message}
    accessibilityState={{
      busy: true
    }}
    className={clsx('flex-1 items-center justify-center gap-2 p-2', className)}
    tabIndex={0}
  >
    <Spinner
      color={COLOR_WHITE}
      size={size === 'lg' ? 'large' : 'small'}
    />
    <Text
      className='color-white/75'
      size={size === 'lg' ? 'md' : 'sm'}
    >
      {message}
    </Text>
  </VStack>
)
